// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `main {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
    justify-content: center;
    align-items: center;
}

/* LEFT SIDE */
.hero {
    position: relative;
    grid-column: 1;
    width: 50vw;
    height: 100vh;
}

.hero:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
        172deg,
        rgb(0, 98, 139) 0%,
        rgba(0, 0, 0, 0.7) 100%
    );
    z-index: 1;
}

.hero img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
}

.hero-text {
    position: relative;
    width: 60%;
    margin: auto;
    z-index: 2;
    margin-top: auto;
    line-height: 1.6;
}

h3 {
    padding: 30px;
    text-align: center;
    color: rgb(178, 178, 178);
}

.logo-overlay {
    position: relative;
    top: 2rem;
    left: 35%;
    z-index: 2;
}

.logo-overlay img {
    max-width: 350px;
    height: auto;
    opacity: 0.4;
}

/* RIGHT SIDE */
.right-section {
    grid-column: 2;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 50vw;
    height: 100vh;
}

.form-container {
    height: 75vh;
    width: 100%;
    padding-top: 35px;
}

form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

fieldset {
    border: none;
    height: 67%;
    color: rgb(108, 105, 105);
    padding: 15px;
}

legend {
    text-align: center;
    padding-left: 20px;
    padding-top: 20px;
    font-weight: 700;
    font-size: 1.5rem;
}

legend a {
    color: inherit !important;
    text-decoration: underline !important;
}

.user-info {
    display: flex;
    margin: 25px;
}

label {
    align-self: flex-start;
    font-size: 0.58em;
    font-weight: 700;
    color: rgb(136, 132, 132);
}

input {
    border: 0.5px solid #e5e7eb;
    border-radius: 3px;
    height: 35px;
}

.first-name {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.last-name {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-left: 20px;
}

.e-mail {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.tel {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-left: 20px;
}

.fleet-size {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.trailer-type {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-left: 20px;
}

input:hover {
    background: rgba(200, 210, 239, 0.1);
}

input:focus {
    border: 1px solid blue;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

/* Show error message when input is invalid and submit button is clicked */
span.show-error {
    position: absolute;
    display: block;
    font-size: 0.6rem;
    color: red;
    top: 33px;
    left: 5px;
}

#confirmation-message.hidden,
.primary-cta.hidden {
    display: none;
}

#confirmation-message {
    display: block;
    margin-top: 2rem;
    color: #4caf50; /* Green for success */
    font-size: 1rem;
    text-align: center;
}

@media (max-width: 1024px) {
    .hero-text {
        margin: 0;
        width: 100%;
    }
    .logo-overlay {
        top: 1.5rem;
        left: 25%;
        width: 250px;
    }
}
@media (max-width: 768px) {
    main {
        grid-template-columns: 1fr;
        grid-template-rows: 600px 880px;
    }
    .hero {
        grid-column: 1;
        grid-row: 2;
        width: 100vw;
    }
    .hero-text {
        margin: 0;
        width: 100%;
    }
    .logo-overlay {
        top: 1.5rem;
        left: 35%;
        width: 250px;
    }
    .right-section {
        grid-column: 1;
        grid-row: 1;
        width: 100vw;
        height: 65vh;
    }
    .form-container {
        height: 80%;
        padding-top: 0;
    }
    fieldset {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 0;
    }
    fieldset .user-info {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 0;
    }
    legend {
        padding: 0;
    }
    .user-info div {
        margin: 10px 0 0 0;
    }
    .user-info input {
        width: 280px;
    }
    .primary-cta {
        margin-top: 30px;
        width: 280px;
    }
}

@media (max-width: 428px) {
    .logo-overlay {
        top: 1rem;
        left: 25%;
        width: 250px;
        transform: translateX(0%);
    }
}

@media (max-width: 350px) {
    .logo-overlay {
        top: 1rem;
        left: 10%;
        width: 250px;
        transform: translateX(0%);
    }
}
`, "",{"version":3,"sources":["webpack://./src/sign-up-form/sign-up.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,cAAc;AACd;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ;;;;KAIC;IACD,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;AAChB;;AAEA,eAAe;AACf;IACI,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,sBAAsB;IACtB,uCAAuC;AAC3C;;AAEA,0EAA0E;AAC1E;IACI,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,UAAU;IACV,SAAS;IACT,SAAS;AACb;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,cAAc,EAAE,sBAAsB;IACtC,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI;QACI,SAAS;QACT,WAAW;IACf;IACA;QACI,WAAW;QACX,SAAS;QACT,YAAY;IAChB;AACJ;AACA;IACI;QACI,0BAA0B;QAC1B,+BAA+B;IACnC;IACA;QACI,cAAc;QACd,WAAW;QACX,YAAY;IAChB;IACA;QACI,SAAS;QACT,WAAW;IACf;IACA;QACI,WAAW;QACX,SAAS;QACT,YAAY;IAChB;IACA;QACI,cAAc;QACd,WAAW;QACX,YAAY;QACZ,YAAY;IAChB;IACA;QACI,WAAW;QACX,cAAc;IAClB;IACA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,UAAU;IACd;IACA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,SAAS;IACb;IACA;QACI,UAAU;IACd;IACA;QACI,kBAAkB;IACtB;IACA;QACI,YAAY;IAChB;IACA;QACI,gBAAgB;QAChB,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,SAAS;QACT,SAAS;QACT,YAAY;QACZ,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,SAAS;QACT,SAAS;QACT,YAAY;QACZ,yBAAyB;IAC7B;AACJ","sourcesContent":["main {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: 1fr;\n    justify-content: center;\n    align-items: center;\n}\n\n/* LEFT SIDE */\n.hero {\n    position: relative;\n    grid-column: 1;\n    width: 50vw;\n    height: 100vh;\n}\n\n.hero:before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(\n        172deg,\n        rgb(0, 98, 139) 0%,\n        rgba(0, 0, 0, 0.7) 100%\n    );\n    z-index: 1;\n}\n\n.hero img {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    z-index: 0;\n}\n\n.hero-text {\n    position: relative;\n    width: 60%;\n    margin: auto;\n    z-index: 2;\n    margin-top: auto;\n    line-height: 1.6;\n}\n\nh3 {\n    padding: 30px;\n    text-align: center;\n    color: rgb(178, 178, 178);\n}\n\n.logo-overlay {\n    position: relative;\n    top: 2rem;\n    left: 35%;\n    z-index: 2;\n}\n\n.logo-overlay img {\n    max-width: 350px;\n    height: auto;\n    opacity: 0.4;\n}\n\n/* RIGHT SIDE */\n.right-section {\n    grid-column: 2;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    width: 50vw;\n    height: 100vh;\n}\n\n.form-container {\n    height: 75vh;\n    width: 100%;\n    padding-top: 35px;\n}\n\nform {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\nfieldset {\n    border: none;\n    height: 67%;\n    color: rgb(108, 105, 105);\n    padding: 15px;\n}\n\nlegend {\n    text-align: center;\n    padding-left: 20px;\n    padding-top: 20px;\n    font-weight: 700;\n    font-size: 1.5rem;\n}\n\nlegend a {\n    color: inherit !important;\n    text-decoration: underline !important;\n}\n\n.user-info {\n    display: flex;\n    margin: 25px;\n}\n\nlabel {\n    align-self: flex-start;\n    font-size: 0.58em;\n    font-weight: 700;\n    color: rgb(136, 132, 132);\n}\n\ninput {\n    border: 0.5px solid #e5e7eb;\n    border-radius: 3px;\n    height: 35px;\n}\n\n.first-name {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.last-name {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin-left: 20px;\n}\n\n.e-mail {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.tel {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin-left: 20px;\n}\n\n.fleet-size {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.trailer-type {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin-left: 20px;\n}\n\ninput:hover {\n    background: rgba(200, 210, 239, 0.1);\n}\n\ninput:focus {\n    border: 1px solid blue;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n}\n\n/* Show error message when input is invalid and submit button is clicked */\nspan.show-error {\n    position: absolute;\n    display: block;\n    font-size: 0.6rem;\n    color: red;\n    top: 33px;\n    left: 5px;\n}\n\n#confirmation-message.hidden,\n.primary-cta.hidden {\n    display: none;\n}\n\n#confirmation-message {\n    display: block;\n    margin-top: 2rem;\n    color: #4caf50; /* Green for success */\n    font-size: 1rem;\n    text-align: center;\n}\n\n@media (max-width: 1024px) {\n    .hero-text {\n        margin: 0;\n        width: 100%;\n    }\n    .logo-overlay {\n        top: 1.5rem;\n        left: 25%;\n        width: 250px;\n    }\n}\n@media (max-width: 768px) {\n    main {\n        grid-template-columns: 1fr;\n        grid-template-rows: 600px 880px;\n    }\n    .hero {\n        grid-column: 1;\n        grid-row: 2;\n        width: 100vw;\n    }\n    .hero-text {\n        margin: 0;\n        width: 100%;\n    }\n    .logo-overlay {\n        top: 1.5rem;\n        left: 35%;\n        width: 250px;\n    }\n    .right-section {\n        grid-column: 1;\n        grid-row: 1;\n        width: 100vw;\n        height: 65vh;\n    }\n    .form-container {\n        height: 80%;\n        padding-top: 0;\n    }\n    fieldset {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        padding: 0;\n    }\n    fieldset .user-info {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        margin: 0;\n    }\n    legend {\n        padding: 0;\n    }\n    .user-info div {\n        margin: 10px 0 0 0;\n    }\n    .user-info input {\n        width: 280px;\n    }\n    .primary-cta {\n        margin-top: 30px;\n        width: 280px;\n    }\n}\n\n@media (max-width: 428px) {\n    .logo-overlay {\n        top: 1rem;\n        left: 25%;\n        width: 250px;\n        transform: translateX(0%);\n    }\n}\n\n@media (max-width: 350px) {\n    .logo-overlay {\n        top: 1rem;\n        left: 10%;\n        width: 250px;\n        transform: translateX(0%);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
